module.exports = __webpack_public_path__ + "static/media/Parent-portal.c27404ac.svg";